// 저장소 키 대장 — 「이 브라우저에 무엇이 어느 이름으로 남는가」의 **단일 정본**
//
// [왜 파일이 하나 더 생겼나] 같은 키 문자열이 소스 다섯 곳에 리터럴로 박혀 있었다:
//   `useGameSettings.js` · `useMapSettings.js` · `originSettings.js`(둘 다) ·
//   `audioManager.js` · `useBlockTextures.js`.
//   그중 셋은 「useGameSettings.js 의 STORAGE_KEY 와 같아야 한다」는 **주석으로만**
//   묶여 있었다 — 주석은 이름을 바꿀 때 같이 안 바뀐다. 키가 갈리면 증상은
//   「설정이 저장은 되는데 다음에 안 읽힌다」이고, 그건 조용해서 늦게 잡힌다.
//
// [규칙] **새 localStorage/sessionStorage 키는 여기 등록하고 여기서 import 한다.**
//   소스에 문자열을 직접 적지 않는다. 이 파일이 곧 「무엇이 남아 있나」의 목록이라,
//   저장공간 탭·초기화 버튼·마이그레이션이 이 한 곳만 보면 된다.
//
// ⚠ **값을 바꾸면 그 브라우저의 저장값이 통째로 사라진다**(다른 이름을 읽으므로).
//   버전을 올릴 때는 옛 키를 `LEGACY` 에 남기고 한 번 옮겨 담는 마이그레이션을 붙인다.

/** 환경설정 본체 — 전투·HUD·패널 위치·카메라·빛·사운드·단축키(≈140키). DB 동기화됨. */
export const GAME_SETTINGS_KEY = 'game_settings_v1';

/** 레이어·지형·가시거리(≈90키). DB 에는 `ui_settings.map_layers` 로 들어간다. */
export const MAP_LAYERS_KEY = 'map_layers_v1';

/** 카메라 — 이 둘만 기기 로컬이다(줌·시점은 기기마다 다른 게 맞다). */
export const CAMERA_ZOOM_KEY = 'game_camera_zoom_level';
export const CAMERA_MODE_KEY = 'game_camera_mode';

/** 바닥 텍스처 모드 — 'partition' | 'terrain'. */
export const GROUND_TEX_MODE_KEY = 'ground_tex_mode';

/** 지운 지 오래됐지만 옛 브라우저에 남아 있는 키 — 진입 시 한 번 지운다. */
export const LEGACY_DEAD_KEYS = ['ground_texture_folder', 'road_texture_folder'];
